import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    isSubscribing: false,
    isUnsubscribing: false,
    isStoringToBackend: false,
    isDeletingFromBackend: false,
    isAnyOperationInProgress: false,
    subscription: null,
    isUpdatingSettings: false,
};

export const slice = createSlice({
    name: 'pushNotification',
    initialState,
    reducers: {
        setPushNotificationSubscribing: (state, action) => {
            state.isSubscribing = action.payload;
        },
        setPushNotificationUnsubscribing: (state, action) => {
            state.isUnsubscribing = action.payload;
        },
        setPushNotificationStoringToBackend: (state, action) => {
            state.isStoringToBackend = action.payload;
        },
        setPushNotificationDeletingFromBackend: (state, action) => {
            state.isDeletingFromBackend = action.payload;
        },
        setPushNotificationSubscription: (state, action) => {
            state.subscription = action.payload;
        },
        resetPushNotificationLoadingStates: (state) => {
            state.isSubscribing = false;
            state.isUnsubscribing = false;
            state.isStoringToBackend = false;
            state.isDeletingFromBackend = false;
        },
        setPushNotificationSettingChangeInProgress: (state, action) => {
            state.isUpdatingSettings = action.payload;
        },
    },
});

export const {
    setPushNotificationSubscribing,
    setPushNotificationUnsubscribing,
    setPushNotificationStoringToBackend,
    setPushNotificationDeletingFromBackend,
    setPushNotificationSubscription,
    resetPushNotificationLoadingStates,
    setPushNotificationSettingChangeInProgress,
} = slice.actions;

export default slice.reducer;
